import React from 'react';
import SurveyPage from '../components/SurveyPage';
import SurveyTitleArea from '../components/SurveyTitleArea';
import SurveySection from '../components/SurveySection';
import SurveyElement from '../components/SurveyElement';
import SurveyContentContainer from '../components/SurveyContentContainer';
import {
  ElementType,
} from '../Enums/constants';



export const PabsUkStartTab = () => {
  return (
    <SurveyPage pageName='Start'>
      <SurveyTitleArea labelText='' />
      <SurveyContentContainer>
        <SurveySection labelText='Basic Information'>
          <SurveyElement
            labelText='Scheme Name'
            note='Please provide us with the name as you would like it to appear on the report.'
            inputType={ElementType.TEXT}
            name='Longname'
            pageName='Start'
            placeholder='Scheme Name'
          />
          <SurveyElement
            labelText='Primary Survey Contact Information'
            pageName='Start'
            placeholder='Primary Contact'
          />
          <SurveyElement
            labelText='Name'
            inputType={ElementType.TEXT}
            name='Name'
            subQuestion
            pageName='Start'
            placeholder='Name'
          />
          <SurveyElement
            labelText='Job Title'
            inputType={ElementType.TEXT}
            name='Title'
            subQuestion
            pageName='Start'
            placeholder='Job Title'
          />
          <SurveyElement
            labelText='Email'
            inputType={ElementType.TEXT}
            name='Email'
            subQuestion
            pageName='Start'
            placeholder='Email'
          />
          <SurveyElement
            labelText='Telephone'
            inputType={ElementType.TEXT}
            name='Telephone'
            subQuestion
            pageName='Start'
            placeholder='Telephone'
          />
          <SurveyElement
            questionNumber='1'
            labelText='What is the year end date for this data (i.e., year ending)?'
            inputType={ElementType.TEXT}
            name='YearEnd'
            placeholder='dd-mm-yyyy'
            pageName='Start'
          />
          <SurveyElement
            questionNumber='2'
            labelText="Would you describe your administration as predominantly 'in-house' or 'outsourced'?"
            inputType={ElementType.RADIOBUTTON}
            name='InOut'
            options={['', 'In-house', 'Outsourced']}
            pageName='Start'
          />
        </SurveySection>
      </SurveyContentContainer>
    </SurveyPage>
  );
};